import { InnerFormTemplate } from "components/MainSectionTemplate/InnerFormTemplate";
import OptionalNumberInput from "components/ValidatedFields/OptionalNumberInput";
import React from "react";

interface Props {
  stage: server.dto.Stage;
  onChange: (value: server.dto.Stage) => void;
  submit: () => void;
  isSaving: boolean;
}

export const StageEdit = (props: Props) => {
  return <InnerFormTemplate
    submit={props.submit}
    isSaving={props.isSaving}
    section={{
      key: "stage",
      title: "",
      type: "regular",
      fields: [
        {
          key: "width",
          label: RESX.Venue.StageWidth,
          renderEditNew: () => (
            <OptionalNumberInput
              width={200}
              value={props.stage.width}
              onChange={(value) => props.onChange({
                ...props.stage,
                width: value
              })}
              onEnterPressed={value => props.onChange({
                ...props.stage,
                width: value
              })}
              labelContent="m"
              decimalPoints={2}
              maxLength={6}
              maxValue={1000}
              canBeEmpty
            />
          ),
        },
        {
          key: "depth",
          label: RESX.Venue.StageDepth,
          renderEditNew: () => (
            <OptionalNumberInput
              width={200}
              value={props.stage.depth}
              onChange={(value) => props.onChange({
                ...props.stage,
                depth: value
              })}
              onEnterPressed={value => props.onChange({
                ...props.stage,
                depth: value
              })}
              labelContent="m"
              decimalPoints={2}
              maxLength={6}
              maxValue={1000}
              canBeEmpty
            />
          ),
        }, {
          key: "toFloor",
          label: RESX.Venue.StageToFloor,
          renderEditNew: () => (
            <OptionalNumberInput
              width={200}
              value={props.stage.toFloor}
              onChange={(value) => props.onChange({
                ...props.stage,
                toFloor: value
              })}
              onEnterPressed={value => props.onChange({
                ...props.stage,
                toFloor: value
              })}
              labelContent="m"
              decimalPoints={2}
              maxLength={6}
              maxValue={1000}
              canBeEmpty
            />
          ),
        },
        {
          key: "toCeiling",
          label: RESX.Venue.StageToCeiling,
          renderEditNew: () => (
            <OptionalNumberInput
              width={200}
              value={props.stage.toCeiling}
              onChange={(value) => props.onChange({
                ...props.stage,
                toCeiling: value
              })}
              onEnterPressed={value => props.onChange({
                ...props.stage,
                toCeiling: value
              })}
              labelContent="m"
              decimalPoints={2}
              maxLength={6}
              maxValue={1000}
              canBeEmpty
            />
          ),
        }
      ]
    }}
  />
}